var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,0.1c-6.6,0-12,5.4-12,12.1s5.4,12.1,12,12.1s12-5.4,12-12.1c0-3.2-1.3-6.3-3.5-8.6 C18.3,1.3,15.3,0.1,12.1,0.1z M12.1,22.2c-5.5,0-10-4.5-10-10.1S6.6,2,12.1,2s10,4.5,10,10.1S17.6,22.2,12.1,22.2z M13.5,18.2h-2 V8.7l-1.9,1.8L8.3,9.1l3.3-3h1.9V18.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoStep1);
export default __webpack_public_path__ + "static/media/ico-step1.eeed8d8ac8824bb2122ed6616d0e043d.svg";
export { ForwardRef as ReactComponent };